module.exports = __webpack_public_path__ + "static/img/network-01.2e0a8d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/network/network-01.jpg
// module id = 52Iu
// module chunks = 1